import { createRoot } from "react-dom/client";
import App from "./App";
let node = document.getElementById("root");

let root = createRoot(node);

root.render(
  <div>
    <App />
  </div>
);
